/**
 * Created by lihanying on 2017/6/29.
 */
import {
  GETCLUBCOMMODITY, GETQINIUTOKEN, GETIMAGEURL,
  GETINSTORAGE, GETCOMMODITYTOTAL, GETCLUBCOMMODITYOUT
} from './constants'

const initState = {}

export default function (state = initState, action) {
  switch (action.type) {
    case GETCLUBCOMMODITY:
      return Object.assign({}, state, { clubCommodity: action.payload })
    case GETCLUBCOMMODITYOUT:
      return Object.assign({}, state, { clubCommodityOut: action.payload })
    case GETQINIUTOKEN:
      return Object.assign({}, state, { qiniuToken: action.payload })
    case GETIMAGEURL:
      return Object.assign({}, state, { imageUrl: action.payload })
    case GETINSTORAGE:
      return Object.assign({}, state, { inStorage: action.payload })
    case GETCOMMODITYTOTAL:
      return Object.assign({}, state, { commodityTotal: action.payload })

    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/containers/ClubCommodity/reduce.js